/* eslint-disable @typescript-eslint/restrict-plus-operands */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
import * as Sentry from '@sentry/react'
import formBuilderAPI from 'api/formBuilderServer'
import { arrayMoveMutable } from 'array-move'
import findLast from 'lodash/findLast'
import forEach from 'lodash/forEach'
import get from 'lodash/get'
import isNil from 'lodash/isNil'
import map from 'lodash/map'
import omitBy from 'lodash/omitBy'
import some from 'lodash/some'
import sumBy from 'lodash/sumBy'
import values from 'lodash/values'
import {
  saveExtraContexts,
  validateExtraContexts,
} from 'pages/Utils/extra-contexts'
import * as React from 'react'
import { type RouteComponentProps, useParams, withRouter } from 'react-router'
import { toast } from 'react-toastify'
import {
  getObjectWithOrWithoutId,
  hasText,
  isFilledArray,
  reorder,
} from 'utils/helpers'
import { v4 as uuid } from 'uuid'

import API from '@/api'
import { CompletePageConditionalRuleModel } from '@/domain/model/forms'
import useIntegration from '@/hooks/useIntegration'
import { useAddNewCompletePageConditionalRules } from '@/queries/questions/useAddNewCompletePageConditionalRules'
import { useDeleteCompletePageConditionalRuleById } from '@/queries/questions/useDeleteCompletePageConditionalRuleById'
import { invalidateLoadCompletePageConditionalRule } from '@/queries/questions/useLoadCompletePageConditionalRule'
import { invalidateLoadQuestionByResourceId } from '@/queries/questions/useLoadQuestionByResourceId'
import { useUpdateCompletePageConditionalRules } from '@/queries/questions/useUpdateCompletePageConditionalRules'
import { useUpdateTeamConfig } from '@/queries/team/useUpdateTeamConfig'
import { Question } from '@/types/question'
import { getSeparateCompleteConditionalRule } from '@/utils/conditionalCompletePage/getSeparateCompleteConditionalRule'
import { QUESTION_TYPES } from '@/utils/constants'
import { FormBuilderPage } from '@/utils/domain/FormBuilder/FormBuilderPage'
import FormBuilderQuestion from '@/utils/domain/FormBuilder/FormBuilderQuestion'
import FormBuilderRow from '@/utils/domain/FormBuilder/FormBuilderRow'
import FormBuilderSection from '@/utils/domain/FormBuilder/FormBuilderSection'
import QuestionChoice from '@/utils/domain/FormBuilder/QuestionChoice'
import { useFormBuilderJsonParser } from '@/utils/domain/FormBuilder/useFormBuilderJsonParser'
import { CONSTANTS_FORM_BUILDER } from '@/utils/FormBuilder/ConstantsFormBuilder'
import ValidationError from '@/utils/FormBuilder/customErrors'
import { generateDuplicateQuestion } from '@/utils/FormBuilder/FormBuilderHelpers'
import formBuilderSchema from '@/utils/FormBuilder/schema'
import stripeAccountStatusEnum from '@/utils/stripeAccountStatusEnum'
import { ZentakeContext } from '@/utils/ZentakeContext'

import { FormAppearanceModel } from '../FormAppearance/useFormAppearance'

// Define key interfaces/types
interface DeletedItems {
  questions: any[]
  question_rows: any[]
  question_columns: any[]
  question_choices: any[]
  conditional_rule_groups: any[]
  conditional_rules: any[]
  pages: any[]
}

export type CompletePageType = {
  redirectUrl?: string | null
  customCompletePage?: string | null
  hasRedirectRules?: boolean | null
  data?: CompletePageConditionalRuleModel[]
}

interface FormBuilderContextType {
  reloadFormData: () => Promise<void>
  // Form properties
  formName: string
  formTextName: string
  formReportType: string | null
  formDisplayName: string
  formDescription: string
  autoSignOffEnabled: boolean
  elationPdfNonFax: boolean
  formDownloadable: boolean
  internalForm: boolean

  // State properties
  pages: Record<string, any>
  sections: Record<string, any>
  questions: Record<string, any>
  rows: Record<string, any>
  pagesArray: any[]
  pagesTreeArray: any[]
  sectionsArray: any[]
  questionsArray: any[]
  rowsArray: any[]
  pagesLength: number

  // Status flags
  isDirty: boolean
  isReordering: boolean
  isSavingForm: boolean
  isFetchingForm: boolean
  isEditingDescription: boolean
  loading: boolean
  deleting: boolean
  setIsDirty: (isDirty: boolean) => void
  measuresEnabledForm: boolean
  setMeasuresEnabledForm: (enabled: boolean) => void

  // UI related
  selectedItem: { id?: string; type?: string; parentPageId?: string }
  conditionalLogicModalOpen: boolean
  questionIdToScroll: string | null
  rowToScroll: string | null
  reorderColumns: number
  reorderSourceRow: any

  // Error handling
  formErrors: string[]
  questionErrors: Record<string, string[]>
  questionValidationTypes: any[]

  // Other data
  notificationUsers: any[]
  extraContexts: Record<string, any>
  serverFormId: string | null

  // Methods - Adding
  addPage: () => void
  addRepeatingSectionAfter: (pageId: string) => void
  addSection: (targetPageId: string) => void
  addChildPageWithQuestion: (
    parentPageId: string,
    questionType: any,
    questionProps?: any
  ) => any
  addRow: (
    targetPage: string,
    targetSection: string,
    questionType: any,
    questionProps?: any
  ) => any
  addQuestion: (targetRow: string, questionProps?: any) => any
  addQuestionChoice: (questionId: string) => void
  addMultipleQuestions: (
    sectionId: string,
    rowId: string,
    questions: any[],
    shouldScrollToNewRow?: boolean
  ) => void
  addRowInBetween: (
    sectionId: string,
    rowIdToAddAfter: string,
    addToFirstLine: boolean,
    questionId?: string | null
  ) => string

  // Methods - Getting
  getIsSelected: (id: string | null, type: string) => boolean
  getPage: (id: string) => any
  getRow: (id: string) => any
  getSection: (id: string) => any
  getQuestion: (id: string) => Question | undefined
  getCurrentQuestion: () => any
  getAllSectionsForPage: (pageId: string) => any[]
  getSectionsForPage: (pageId: string) => any[]
  getOnDeleteForm: (formId: string) => () => void
  getOnPreviewForm: (formId: string) => () => void

  // Methods - Deleting
  deletePage: (pageId: string) => void
  deleteSection: (sectionId: string) => void
  deleteQuestion: (questionId: string) => Promise<void>
  removeQuestionChoice: (questionId: string, choiceId: string) => void

  // Methods - Updating
  setPage: (pageId: string, nextPage: any) => void
  setQuestion: (questionId: string, nextQuestion: any) => void
  setQuestions: (questions: Record<string, any>) => void
  updateMultipleQuestions: (questions: any[]) => void

  // Methods - Form Actions
  onSaveForm: () => Promise<void>
  onDeleteForm: (formId: string) => Promise<void>
  onPreviewForm: (formId: string) => Promise<void>
  validateFormData: () => Promise<boolean>
  buildFromResponse: (response: any) => void

  // Methods - Reordering
  onReorderQuestion: (params: {
    questionId: string
    fromRowId: string
    toRowId: string
    toRowIndex: number
  }) => void
  onReorderQuestionProp: (
    questionId: string,
    propKey: string,
    propId: string,
    sourceIndex: number,
    destinationIndex: number
  ) => void
  onReorderQuestionToNewRow: (params: {
    questionId: string
    toSectionId: string
  }) => any
  onMovePageUp: (pageId: string) => void
  onMovePageDown: (pageId: string) => void
  orderAllQuestions: () => any[]

  // Methods - Setters
  setFormName: (name: string) => void
  setFormTextName: (name: string) => void
  setFormDisplayName: (name: string) => void
  setFormDescription: (description: string) => void
  setFormReportType: (type: string | null) => void
  setAutoSignOffEnabled: (enabled: boolean) => void
  setElationPdfNonFax: (enabled: boolean) => void
  setFormDownloadable: (downloadable: boolean) => void
  setInternalForm: (internal: boolean) => void
  setIsEditingDescription: (editing: boolean) => void
  setIsFetchingForm: (fetching: boolean) => void
  setIsReordering: (reordering: boolean) => void
  setNotificationUsers: (users: any[]) => void
  setReorderColumns: (columns: number) => void
  setReorderSourceRow: (row: any) => void
  setRowToScroll: (rowId: string | null) => void
  setSelectedItem: React.Dispatch<
    React.SetStateAction<{ id?: string; type?: string; parentPageId?: string }>
  >
  setQuestionIdToScroll: (id: string | null) => void
  setConditionalLogicModalOpen: (open: boolean) => void
  setExtraContexts: (contexts: Record<string, any>) => void

  // design methods
  handleUpdateAppearanceDetails: (
    appearanceDetails: FormAppearanceModel
  ) => void

  // Utility methods
  resetSelectedItem: () => void
  shouldHideCreditCardQuestion: (questionType: string) => boolean
}

interface ContextFormBuilderProviderBaseProps
  extends RouteComponentProps<any, any, any> {
  children: React.ReactNode
}

export const FormBuilderContext = React.createContext<FormBuilderContextType>(
  {} as FormBuilderContextType
)

function ContextFormBuilderProviderBase({
  children,
  history,
}: ContextFormBuilderProviderBaseProps) {
  const zentakeContext = React.useContext(ZentakeContext)
  const params = useParams<{ resourceId?: string }>()
  const resourceFormId = params.resourceId
  const { integration } = useIntegration()
  const { parseFormFromJson } = useFormBuilderJsonParser()
  const stripeIntegration = zentakeContext?.stripeIntegration
  const stripeAccountStatus = zentakeContext?.stripeAccountStatus
  const { updateTeamConfig } = useUpdateTeamConfig()
  const { addNewCompletePageConditionalRules } =
    useAddNewCompletePageConditionalRules()
  const { updateCompletePageConditionalRules } =
    useUpdateCompletePageConditionalRules()
  const { deleteCompletePageConditionalRuleById } =
    useDeleteCompletePageConditionalRuleById()

  const notIsSettings = !history.location.pathname.includes('settings')
  const isNewForm = history.location.pathname.includes('/forms/new')

  const formId = React.useRef(uuid()).current

  const measuresEnabled = zentakeContext.teamDetails?.measures

  const [serverFormId, setServerFormId] = React.useState<string | null>(null)
  const [formName, _setFormName] = React.useState('')
  const [formTextName, setFormTextName] = React.useState('')
  const [formDisplayName, setFormDisplayName] = React.useState('')
  const [formDescription, setFormDescription] = React.useState('')
  const [formReportType, setFormReportType] = React.useState<string | null>(
    null
  )
  const [autoSignOffEnabled, setAutoSignOffEnabled] = React.useState(false)
  const [elationPdfNonFax, setElationPdfNonFax] = React.useState(false)
  const [formDownloadable, setFormDownloadable] = React.useState(false)
  const [internalForm, setInternalForm] = React.useState(false)
  const [measuresEnabledForm, setMeasuresEnabledForm] = React.useState(false)
  const [appearanceDetailsForm, setAppearanceDetailsForm] = React.useState<
    FormAppearanceModel | undefined
  >(undefined)
  const [isSavingForm, setIsSavingForm] = React.useState(false)
  const [isFetchingForm, setIsFetchingForm] = React.useState(false)
  const [isEditingDescription, setIsEditingDescription] = React.useState(false)
  const [formErrors, setFormErrors] = React.useState<string[]>([])
  const [questionErrors, setQuestionErrors] = React.useState<
    Record<string, string[]>
  >({})
  const [questionIdToScroll, setQuestionIdToScroll] = React.useState<
    string | null
  >(null)
  const [isDirty, setIsDirty] = React.useState(false)
  const [rowToScroll, setRowToScroll] = React.useState<string | null>(null)
  const [isReordering, setIsReordering] = React.useState(false)
  const [reorderColumns, setReorderColumns] = React.useState(0)
  const [reorderSourceRow, setReorderSourceRow] = React.useState<any>(null)
  const [questionValidationTypes, setQuestionValidationTypes] = React.useState(
    []
  )
  const [notificationUsers, setNotificationUsers] = React.useState<any[]>([])

  const [completePage, setCompletePage] = React.useState<
    CompletePageType | undefined
  >(undefined)

  const [loading, setLoading] = React.useState(false)
  const [deleting, setDeleting] = React.useState(false)

  const setFormName = React.useCallback((name: string) => {
    _setFormName(name)
    setIsDirty(true)
  }, [])

  // shenanigan
  const [extraContexts, setExtraContexts] = React.useState({})

  const INITIAL_DELETED_ITEMS: DeletedItems = React.useMemo(
    () => ({
      questions: [],
      question_rows: [],
      question_columns: [],
      question_choices: [],
      conditional_rule_groups: [],
      conditional_rules: [],
      pages: [],
    }),
    []
  )

  const [deletedItems, setDeletedItems] = React.useState(INITIAL_DELETED_ITEMS)

  const FORM_INITIAL_VALUE = CONSTANTS_FORM_BUILDER.INITIAL_EMPTY_FORM()

  const [pages, setPages] = React.useState(FORM_INITIAL_VALUE.PAGE)

  const [pagesLength, setPagesLength] = React.useState(
    values(pages)?.length ?? 0
  )

  React.useEffect(() => {
    setPagesLength(values(pages)?.length ?? 0)
  }, [pages])

  const [sections, setSections] = React.useState(FORM_INITIAL_VALUE.SECTION)

  const [rows, setRows] = React.useState(FORM_INITIAL_VALUE.ROW)

  const [questions, setQuestions] = React.useState<Record<string, any>>(
    FORM_INITIAL_VALUE.QUESTION
  )

  const [selectedItem, setSelectedItem] = React.useState<{
    id?: string
    type?: string
    parentPageId?: string
  }>({
    id: CONSTANTS_FORM_BUILDER.SELECTION_TYPE.FORM,
    type: CONSTANTS_FORM_BUILDER.SELECTION_TYPE.FORM,
  })

  const [conditionalLogicModalOpen, setConditionalLogicModalOpen] =
    React.useState(false)

  React.useEffect(() => {
    API.getQuestionValidationTypes()
      .then((response) => {
        setQuestionValidationTypes(response)
      })
      .catch((error) => {
        console.error('Error fetching question validation types:', error)
      })
  }, [])

  const _objectToArray = React.useCallback(
    (obj: Record<string, any>) =>
      Object.keys(obj).map((key) => ({ id: key, ...obj[key] })),
    []
  )

  const pagesArray = React.useMemo(
    () => _objectToArray(pages).sort((a, b) => a.order - b.order),
    [_objectToArray, pages]
  )

  const sectionsArray = React.useMemo(
    () => _objectToArray(sections),
    [_objectToArray, sections]
  )

  const rowsArray = React.useMemo(
    () => _objectToArray(rows),
    [_objectToArray, rows]
  )

  const questionsArray = React.useMemo(
    () => _objectToArray(questions),
    [_objectToArray, questions]
  )

  const getIsSelected = React.useCallback(
    (id: string | null, type: string) =>
      (id === null && type === CONSTANTS_FORM_BUILDER.SELECTION_TYPE.PAGE) ||
      (hasText(selectedItem?.id) &&
        selectedItem.id === id &&
        hasText(selectedItem?.type) &&
        selectedItem.type === type),
    [selectedItem]
  )

  const resetSelectedItem = React.useCallback(() => {
    setSelectedItem({} as any)
  }, [])

  const getPage = React.useCallback((id: string) => pages[id], [pages])
  const getRow = React.useCallback((id: string) => rows[id], [rows])

  const getSection = React.useCallback((id: string) => sections[id], [sections])
  const getQuestion = React.useCallback(
    (id: string) => questions[id],
    [questions]
  )
  const getCurrentQuestion = React.useCallback(
    () => questions?.[selectedItem.id || selectedItem.parentPageId || ''],
    [questions, selectedItem]
  )

  const getAllSectionsForPage = React.useCallback(
    (pageId: string, allSections: any[] = []) => {
      const pageSections = sectionsArray.filter((s) => s.page === pageId)
      allSections.push(...pageSections)

      const childPages = pagesArray.filter((p) => p.parent_page_id === pageId)
      childPages.forEach((childPage) => {
        getAllSectionsForPage(childPage.id, allSections)
      })

      return allSections
    },
    [sectionsArray, pagesArray]
  )

  const getSectionsForPage = React.useCallback(
    (pageId: string) => {
      return sectionsArray.filter((s) => s.page === pageId)
    },
    [sectionsArray]
  )

  const addPage = React.useCallback(
    (repeat_section?: boolean) => {
      const order = Math.max(...pagesArray.map((p) => p.order), -1) + 1

      const newPage = new FormBuilderPage({
        formId,
        order,
        repeat_section,
      })

      setPages((prevPages) => ({ ...prevPages, [newPage.id]: newPage }))
      // @ts-ignore
      const newSection = new FormBuilderSection({ page: newPage.id })

      setSections((prevSections) => ({
        ...prevSections,
        [newSection.id]: newSection,
      }))

      setIsDirty(true)
    },
    [formId, pagesArray]
  )

  const addRepeatingSectionAfter = React.useCallback(
    (pageId: string) => {
      const targetPage = pagesArray.find((p) => p.id === pageId)
      if (!targetPage) return

      const newOrder = targetPage.order + 1

      const newPage = new FormBuilderPage({
        formId,
        order: newOrder,
        repeat_section: true,
        parent_page_id: pageId,
      })

      setPages((prevPages) => {
        const updatedPages = { ...prevPages }
        updatedPages[newPage.id] = newPage

        if (updatedPages[pageId]) {
          updatedPages[pageId].allow_empty = true
        }

        Object.keys(updatedPages).forEach((key) => {
          const page = updatedPages[key]
          if (page.order >= newOrder && page.id !== newPage.id) {
            page.order += 1
          }
        })
        return updatedPages
      })

      // @ts-ignore
      const newSection = new FormBuilderSection({ page: newPage.id })
      setSections((prevSections) => ({
        ...prevSections,
        [newSection.id]: newSection,
      }))

      setIsDirty(true)
    },
    [formId, pagesArray]
  )

  const addSection = React.useCallback((targetPageId: string) => {
    // @ts-ignore
    const newSection = new FormBuilderSection({ page: targetPageId })

    setSections((prevSections) => ({
      ...prevSections,
      [newSection.id]: newSection,
    }))

    // @ts-ignore
    const newRow = new FormBuilderRow({ section: newSection.id })
    setRows((p) => ({ ...p, [newRow.id]: newRow }))
    setIsDirty(true)
  }, [])

  const alreadyHasCreditCardQuestion = React.useCallback(() => {
    return !!_objectToArray(questions)?.find(
      (question) =>
        question.question_type.question_type === QUESTION_TYPES.credit_card.id
    )
  }, [_objectToArray, questions])

  const isCreditCardQuestionType = React.useCallback(
    (questionType: string) => questionType === QUESTION_TYPES.credit_card.id,
    []
  )

  const shouldHideCreditCardQuestion = React.useCallback(
    (questionType: string) => {
      if (!isCreditCardQuestionType(questionType)) return false

      const STRIPE_ENABLED = process.env.REACT_APP_STRIPE_ENABLED === 'true'

      if (!STRIPE_ENABLED) return true

      return (
        !(
          stripeIntegration?.account_id ||
          stripeIntegration?.api_publishable_key
        ) ||
        stripeAccountStatus === stripeAccountStatusEnum.NOT_CREATED ||
        stripeAccountStatus === stripeAccountStatusEnum.ERROR ||
        stripeAccountStatus === stripeAccountStatusEnum.DISCONNECTED ||
        alreadyHasCreditCardQuestion()
      )
    },
    [
      stripeIntegration,
      stripeAccountStatus,
      alreadyHasCreditCardQuestion,
      isCreditCardQuestionType,
    ]
  )

  const getHighestRowOrder = React.useCallback(
    (sectionId: string) => {
      const sectionRows = rowsArray.filter((r) => r.section === sectionId)
      if (sectionRows.length === 0) return 0

      return Math.max(...sectionRows.map((r) => r.order))
    },
    [rowsArray]
  )

  const updateMultipleQuestions = (questions: any[]) => {
    setQuestions((previousQuestions: Record<string, any>) => {
      const updatedQuestions = questions.reduce(
        (acc: Record<string, any>, question: any) => {
          acc[question.id] = { ...question, hasChanged: true }
          return acc
        },
        {}
      )

      return {
        ...previousQuestions,
        ...updatedQuestions,
      }
    })

    setIsDirty(true)
  }

  const addRow = React.useCallback(
    (
      targetPage: string,
      targetSection: string,
      questionType: any,
      questionProps = {}
    ) => {
      if (shouldHideCreditCardQuestion(questionType.question_type)) {
        return
      }

      const newRowOrder = getHighestRowOrder(targetSection) + 1
      // Add new section's row
      // @ts-ignore
      const newRow = new FormBuilderRow({
        section: targetSection,
        order: newRowOrder,
      })
      setRows((p) => ({ ...p, [newRow.id]: newRow }))
      // Add new question
      // @ts-ignore
      const newQuestion = new FormBuilderQuestion({
        section: targetSection,
        row: newRow.id,
        question_type: questionType,
        ...questionProps,
      })
      setQuestions((prevQuestions: Record<string, any>) => ({
        ...prevQuestions,
        [newQuestion.id]: newQuestion,
      }))
      // Update form order
      setIsDirty(true)
      return newQuestion
    },
    [getHighestRowOrder, shouldHideCreditCardQuestion]
  )

  const addChildPageWithQuestion = React.useCallback(
    (parentPageId: string, questionType: any, questionProps = {}) => {
      if (shouldHideCreditCardQuestion(questionType.question_type)) {
        return
      }

      const order = Math.max(...pagesArray.map((p) => p.order), -1) + 1

      const newPage = new FormBuilderPage({
        formId,
        order,
        repeat_section: false,
        parent_page_id: parentPageId,
      })

      setPages((prevPages) => ({ ...prevPages, [newPage.id]: newPage }))

      // @ts-ignore
      const newSection = new FormBuilderSection({ page: newPage.id })

      setSections((prevSections) => ({
        ...prevSections,
        [newSection.id]: newSection,
      }))

      const newQuestion = addRow(
        newPage.id,
        newSection.id,
        questionType,
        questionProps
      )

      setIsDirty(true)
      return newQuestion
    },
    [
      formId,
      pagesArray,
      setPages,
      setSections,
      addRow,
      shouldHideCreditCardQuestion,
    ]
  )

  const handleUpdateAppearanceDetails = (
    appearanceDetails: FormAppearanceModel
  ) => {
    setIsDirty(true)
    setAppearanceDetailsForm(appearanceDetails)
  }

  const addQuestion = React.useCallback(
    (targetRow: string, questionProps = {}) => {
      const row = rows[targetRow]
      const section = getSection(row.section)
      // Add new question
      const questionList = _objectToArray(questions)
      const rowQuestions = questionList.filter((q) => q.row === row.id)
      // @ts-ignore
      const newQuestion = new FormBuilderQuestion({
        section: section.id,
        row: targetRow,
        order: rowQuestions.length,
        ...questionProps,
      })

      if (
        shouldHideCreditCardQuestion(newQuestion.question_type.question_type)
      ) {
        return
      }

      setQuestions((prevQuestions) => ({
        ...prevQuestions,
        [newQuestion.id]: newQuestion,
      }))
      // Update form order
      setIsDirty(true)
      return newQuestion
    },
    [rows, getSection, _objectToArray, questions, shouldHideCreditCardQuestion]
  )

  const addMultipleQuestions = React.useCallback(
    (
      sectionId: string,
      rowId: string,
      questions: any[],
      shouldScrollToNewRow: boolean
    ) => {
      const baseRow = getRow(rowId)

      // set a new row
      const newRowOrder = baseRow
        ? baseRow.order
        : getHighestRowOrder(sectionId) + 1

      // @ts-ignore
      const newRow = new FormBuilderRow({
        section: sectionId,
        order: newRowOrder,
      })
      setRows((p) => ({ ...p, [newRow.id]: newRow }))

      // create questions

      const newQuestions = {}

      questions.forEach((question, index) => {
        const newQuestion = new FormBuilderQuestion({
          ...question,
          section: sectionId,
          row: newRow.id,
          order: index,
        })

        // add question choices to questions

        if (question.question_choices?.length > 0) {
          newQuestion.question_choices = question.question_choices.map(
            (choice: any, index: number) =>
              // @ts-ignore
              new QuestionChoice({
                order: index,
                question: newQuestion.id,
                text_value: choice,
              })
          )
        }

        // @ts-ignore
        newQuestions[newQuestion.id] = newQuestion
      })

      setQuestions((prevQuestions) => ({
        ...prevQuestions,
        ...newQuestions,
      }))

      // update form order

      shouldScrollToNewRow && setRowToScroll(newRow.id)
    },
    [getHighestRowOrder, getRow]
  )

  // SETTERS
  const setPage = React.useCallback((pageId: string, nextPage: any) => {
    setPages((prevPages: Record<string, any>) => ({
      ...prevPages,
      [pageId]: nextPage,
    }))
    setIsDirty(true)
  }, [])

  const setQuestion = React.useCallback(
    (questionId: string, nextQuestion: any) => {
      const question = getQuestion(questionId)
      setQuestions((prevQuestions: Record<string, any>) => ({
        ...prevQuestions,
        [questionId]: { ...nextQuestion, hasChanged: true },
      }))

      setDeletedItems((deletedItems) => {
        deletedItems.question_choices.push(
          ...question.question_choices.filter(
            (c: any) =>
              !c.isNew &&
              !nextQuestion.question_choices
                .map((t: any) => t.id)
                .includes(c.id)
          )
        )

        deletedItems.question_rows.push(
          ...question.question_rows.filter(
            (r: any) =>
              !r.isNew &&
              !nextQuestion.question_rows.map((t: any) => t.id).includes(r.id)
          )
        )

        deletedItems.question_columns.push(
          ...question.question_columns.filter(
            (c: any) =>
              !c.isNew &&
              !nextQuestion.question_columns
                .map((t: any) => t.id)
                .includes(c.id)
          )
        )

        const questionConditionalRules = question.conditional_rule_groups
          .map((c: any) => c.conditional_rules)
          .flat()
          .filter((c: any) => Boolean(c))
          .map((c: any) => c.id)

        const nextQuestionConditionalRules =
          nextQuestion.conditional_rule_groups
            .map((c: any) => c.conditional_rules)
            .flat()
            .filter((c: any) => Boolean(c))
            .map((c: any) => c.id)

        deletedItems.conditional_rules.push(
          ...questionConditionalRules
            .filter((q: any) => typeof q !== 'string' || !q.startsWith('new-'))
            .filter((q: any) => !nextQuestionConditionalRules.includes(q))
            .map((c: any) => ({ id: c }))
        )

        const questionConditionalRuleGroups =
          question.conditional_rule_groups.map((c: any) => c.id)

        const nextQuestionConditionalRuleGroups =
          nextQuestion.conditional_rule_groups.map((c: any) => c.id)

        deletedItems.conditional_rule_groups.push(
          ...questionConditionalRuleGroups
            .filter((c: any) => typeof c !== 'string' || !c.startsWith('new-'))
            .filter((c: any) => !nextQuestionConditionalRuleGroups.includes(c))
            .map((c: any) => ({ id: c }))
        )

        return deletedItems
      })

      setIsDirty(true)
    },
    [getQuestion]
  )

  const addQuestionChoice = React.useCallback(
    (questionId: string) => {
      const question = getQuestion(questionId)
      const { question_choices } = question

      const order =
        Math.max(...question_choices.map((q: any) => q.order), -1) + 1

      const newChoice = new QuestionChoice({
        order,
        // @ts-ignore
        question: questionId,
      })

      setQuestion(question.id, {
        ...question,
        question_choices: [...(question.question_choices ?? []), newChoice],
      })
    },
    [getQuestion, setQuestion]
  )

  const removeQuestionChoice = React.useCallback(
    (questionId: string, choiceId: string) => {
      const question = getQuestion(questionId)
      setQuestion(questionId, {
        ...question,
        question_choices: question.question_choices.filter(
          (c: any) => c.id !== choiceId
        ),
      })
    },
    [getQuestion, setQuestion]
  )

  const addRowInBetween = React.useCallback(
    (
      sectionId: string,
      rowIdToAddAfter: string,
      addToFirstLine: boolean,
      questionId = null
    ) => {
      const rows = rowsArray.sort((a, b) => a.order - b.order)
      const baseRow = rows?.find((r) => r.id === rowIdToAddAfter)

      // @ts-ignore
      const newRow = new FormBuilderRow({
        section: sectionId,
      })

      const fromIndex = rows.indexOf(newRow)
      let toIndex

      if (addToFirstLine) {
        toIndex = 0
      } else {
        toIndex = rows.indexOf(baseRow)
      }

      rows.push(newRow)
      arrayMoveMutable(rows, fromIndex, toIndex)

      setRows((prevRows) => {
        const newRows = { ...prevRows }

        rows.forEach((r, index) => {
          newRows[r.id] = {
            ...r,
            order: addToFirstLine ? index + 1 : index, // Due to an API feature or bug, we can't use index 0 when it's first blue line
            hasChanged: true,
          }
        })

        return newRows
      })

      if (questionId) {
        const questionObj = getQuestion(questionId)
        setQuestion(questionId, {
          ...questionObj,
          section: sectionId,
          order: 0,
          row: newRow.id,
        })
      }

      return newRow.id
    },
    [getQuestion, rowsArray, setQuestion]
  )

  const duplicateQuestion = React.useCallback(
    (questionIdToDuplicate: string) => {
      const baseQuestion = getQuestion(questionIdToDuplicate)
      const baseRow = getRow(baseQuestion.row)
      // @ts-ignore
      const newRow = new FormBuilderRow({
        section: baseQuestion.section,
        order: (baseRow?.order ?? 0) + 1,
      })
      // trust the magic numbers. first line can't start at 0 due to an
      // api bug (or feature?)

      const duplicatedQuestion = generateDuplicateQuestion(
        baseQuestion,
        newRow.id
      )
      setQuestions((prevQuestions) => ({
        ...prevQuestions,
        [duplicatedQuestion.id]: duplicatedQuestion,
      }))

      // increment order for next rows
      const updatedRows = {}
      forEach(rows, (row: any) => {
        if (row.section === baseQuestion.section && row.order >= newRow.order) {
          // @ts-ignore
          updatedRows[row.id] = {
            ...row,
            order: (row?.order ?? 0) + 1,
            hasChanged: true,
          }
        }
      })

      setRows((p) => ({ ...p, ...updatedRows, [newRow.id]: newRow }))

      return duplicatedQuestion.id
    },
    [getQuestion, getRow, rows]
  )

  // DELETE
  const deletePage = React.useCallback(
    (pageId: string) => {
      setPages((prevPages: Record<string, any>) => {
        const { [pageId]: remove, ...nextPages } = prevPages
        return nextPages
      })

      const sectionIdsRemoved: string[] = []
      setSections((prevSections: Record<string, any>) =>
        omitBy(prevSections, (section: any) => {
          if (section.page === pageId) {
            sectionIdsRemoved.push(section.id)
            return true
          }
          return false
        })
      )

      setQuestions((prevQuestions: Record<string, any>) =>
        omitBy(prevQuestions, ({ section }) =>
          some(sectionIdsRemoved, (sectionId: string) => sectionId === section)
        )
      )

      setDeletedItems((deletedItems) => {
        const removedSections = sectionsArray
          .filter((s: any) => s.page === pageId)
          .map((s: any) => s.id)

        deletedItems.questions = [
          ...deletedItems.questions,
          ...questionsArray.filter(
            (q) => removedSections.includes(q.section) && !q.isNew
          ),
        ]

        const deletedPage = getPage(pageId)

        if (!deletedPage.isNew) {
          deletedItems.pages = [...deletedItems.pages, getPage(pageId)]
        }

        return deletedItems
      })

      setSelectedItem({
        type: CONSTANTS_FORM_BUILDER.SELECTION_TYPE.FORM,
        id: 'form',
      })

      setIsDirty(true)
    },
    [getPage, questionsArray, sectionsArray]
  )

  const deleteSection = React.useCallback((sectionId: string) => {
    setQuestions((prevQuestions: Record<string, any>) =>
      omitBy(prevQuestions, ({ section }) => section === sectionId)
    )
    setSections((prevSections: Record<string, any>) => {
      const { [sectionId]: remove, ...nextSections } = prevSections
      return nextSections
    })
    setIsDirty(true)
  }, [])

  const getConditionalRulesToDelete = React.useCallback(
    (questionIdToDelete: string) => {
      return questionsArray.reduce((acc: string[], question: any) => {
        question.conditional_rule_groups.forEach((group: any) => {
          group.conditional_rules.forEach((rule: any) => {
            if (rule.question.toString() === questionIdToDelete.toString()) {
              acc.push(rule.id)
            }
          })
        })
        return acc
      }, [])
    },
    [questionsArray]
  )

  const deleteQuestion = React.useCallback(
    async (questionId: string) => {
      const { [questionId]: questionToRemove, ...nextQuestions } = questions

      const questionsArray = _objectToArray(nextQuestions)

      const conditionalRulesToDelete = getConditionalRulesToDelete(questionId)

      if (conditionalRulesToDelete.length > 0) {
        const confirmation = await new Promise((resolve) =>
          zentakeContext.setAlertConfig({
            title: 'Alert',
            description:
              'Deleting this question will remove its associated conditional logic and may impact the flow of your form. Are you sure you want to proceed?',
            buttons: [
              {
                title: 'Cancel',
                onPress: () => resolve(false),
              },
              {
                title: 'Yes',
                style: 'primary',
                onPress: () => resolve(true),
              },
            ],
            canDismiss: false,
          })
        )

        if (!confirmation) return
      }

      setSelectedItem({
        type: CONSTANTS_FORM_BUILDER.SELECTION_TYPE.FORM,
        id: 'form',
      })

      const questionsInRow = questionsArray.filter(
        (q) => q.row === questionToRemove.row
      )

      questionsInRow.forEach((q, i) => {
        q.order = i
      })

      const updatedQuestions = {}

      questionsArray.forEach((q: any) => {
        // @ts-ignore
        updatedQuestions[q.id] = {
          ...q,
          conditional_rule_groups: q.conditional_rule_groups
            ?.map((group: any) => {
              return {
                ...group,
                conditional_rules: group.conditional_rules.filter(
                  (rule: any) => !conditionalRulesToDelete.includes(rule.id)
                ),
              }
            })
            ?.filter((group: any) => group.conditional_rules.length > 0),
        }
      })

      setQuestions(updatedQuestions)

      setDeletedItems((deletedItems) => {
        if (!questionToRemove?.isNew) {
          deletedItems.questions.push(questionToRemove)
        }

        return deletedItems
      })

      setIsDirty(true)
    },
    [_objectToArray, getConditionalRulesToDelete, questions, zentakeContext]
  )

  function onReorderQuestionToNewRow({
    questionId,
    toSectionId,
  }: {
    questionId: string
    toSectionId: string
  }) {
    const section = getSection(toSectionId)
    const newRowOrder = getHighestRowOrder(toSectionId) + 1

    // @ts-ignore
    const newRow = new FormBuilderRow({
      section: toSectionId,
      order: newRowOrder,
    })

    const question = getQuestion(questionId)
    question.row = newRow.id
    question.section = section.id
    newRow.questions = [question]

    const rowsInSection = rowsArray
      .filter((r: any) => r.section === toSectionId)
      .sort((a, b) => a.order - b.order)

    rowsInSection.push(newRow)

    setRows((rows) => {
      const newRows = { ...rows }

      rowsInSection.forEach((row: any, index: number) => {
        newRows[row.id] = { ...row, order: index }
      })

      return newRows
    })

    setQuestion(question.id, { ...question })

    return newRow
  }

  const _willSquishRow = React.useCallback(
    (rowId: string) => {
      const rowQuestions = questionsArray.filter((q) => q.row === rowId)
      const filledRows = sumBy(rowQuestions, 'display_columns')
      const willSquish = filledRows >= 12
      const remainingColumns = 12 - filledRows
      const willSquishNewItem = !willSquish && reorderColumns > remainingColumns

      const rowToSquish = willSquish
        ? findLast(
            rowQuestions,
            ({ display_columns }: any) => display_columns > 1
          )
        : null

      return {
        willSquish, // if will squish a row item to fit the new item
        willSquishNewItem,
        remainingColumns,
        rowIndexToAdd: rowQuestions.length, // the index to add the new item
        rowToSquish,
      }
    },
    [questionsArray, reorderColumns]
  )

  const moveQuestionToSameRow = React.useCallback(
    (rowId: string, questionId: string, toIndex: number) => {
      setQuestions((questions: Record<string, any>) => {
        const newQuestions = {
          ...questions,
        }

        const questionsInRow = _objectToArray(questions)
          .filter((q: any) => q.row === rowId)
          .sort((a, b) => a.order - b.order)

        const question = questionsInRow?.find((q: any) => q.id === questionId)
        arrayMoveMutable(
          questionsInRow,
          questionsInRow.indexOf(question),
          toIndex
        )

        questionsInRow.forEach((question: any) => {
          newQuestions[question.id] = {
            ...question,
            order: questionsInRow.indexOf(question),
            hasChanged: true,
          }
        })

        return newQuestions
      })
    },
    [_objectToArray]
  )

  const moveQuestionToDifferentRow = React.useCallback(
    (toRowId: string, toRowIndex: number, question: any) => {
      const { section: toSectionId } = getRow(toRowId)

      const {
        willSquish,
        willSquishNewItem,
        remainingColumns,
        rowIndexToAdd,
        rowToSquish,
      } = _willSquishRow(toRowId)

      if (willSquish) {
        setQuestion(question.id, {
          ...question,
          section: toSectionId,
          row: toRowId,
          order: rowIndexToAdd,
          display_columns: 1,
        })

        if (!isNil(rowToSquish.id)) {
          setQuestion(rowToSquish.id, {
            ...rowToSquish,
            display_columns: rowToSquish.display_columns - 1,
          })
        }
      } else {
        const questionsInRow = questionsArray
          .filter((q) => q.row === toRowId)
          .sort((a, b) => a.order - b.order)

        questionsInRow.push(question)

        arrayMoveMutable(
          questionsInRow,
          questionsInRow.indexOf(question),
          toRowIndex
        )

        setQuestions((questions) => {
          const newQuestions = { ...questions }

          questionsInRow.forEach((q, i) => {
            if (q.id !== question.id) {
              newQuestions[q.id] = { ...q, order: i, hasChanged: true }
            } else {
              newQuestions[q.id] = {
                ...q,
                hasChanged: true,
                section: toSectionId,
                row: toRowId,
                order: i,
                ...(willSquishNewItem
                  ? { display_columns: remainingColumns }
                  : {}),
              }
            }
          })

          return newQuestions
        })
      }
    },
    [_willSquishRow, getRow, questionsArray, setQuestion]
  )

  const onReorderQuestion = React.useCallback(
    ({
      questionId,
      fromRowId,
      toRowId,
      toRowIndex,
    }: {
      questionId: string
      fromRowId: string
      toRowId: string
      toRowIndex: number
    }) => {
      const question = getQuestion(questionId)

      if (fromRowId === toRowId) {
        return moveQuestionToSameRow(toRowId, questionId, toRowIndex)
      }

      return moveQuestionToDifferentRow(toRowId, toRowIndex, question)
    },
    [getQuestion, moveQuestionToDifferentRow, moveQuestionToSameRow]
  )

  function onReorderQuestionProp(
    questionId: string,
    propKey: string,
    propId: string,
    sourceIndex: number,
    destinationIndex: number
  ) {
    const question = getQuestion(questionId)
    const originalList = question[propKey]
    const newList = reorder(originalList, sourceIndex, destinationIndex)
    const reorderedList = map(newList, (item: any, index: number) => ({
      ...item,
      order: index,
    }))
    setQuestion(questionId, {
      ...question,
      [propKey]: reorderedList,
    })
  }

  function onMovePage(
    pageId: string,
    getToIndex: (pageIndex: number) => number
  ) {
    const page = pagesArray?.find((p: any) => p.id === pageId)
    const pageIndex = pagesArray.indexOf(page)
    if (pageIndex === -1) return
    arrayMoveMutable(pagesArray, pageIndex, getToIndex(pageIndex))

    setPages((pages) => {
      const newPages = { ...pages }

      pagesArray.forEach((p: any, index: number) => {
        newPages[p.id] = { ...p, order: index, hasChanged: true }
      })

      return newPages
    })

    setIsDirty(true)
  }

  function onMovePageUp(pageId: string) {
    return onMovePage(pageId, (index: number) => index - 1)
  }

  function onMovePageDown(pageId: string) {
    return onMovePage(pageId, (index: number) => index + 1)
  }

  const buildFromResponse = React.useCallback(
    (response: any) => {
      const {
        autoSignOffEnabled,
        elationPdfNonFax,
        formDownloadable,
        formId,
        formName,
        formReportType,
        formTextName,
        internalForm,
        measuresEnabledForm,
        notificationUsers,
        pages,
        questions,
        redirectUrl,
        customCompletePage,
        hasRedirectRules,
        rows,
        sections,
      } = parseFormFromJson(response)

      setFormName(formName)
      setFormTextName(formTextName ?? '')
      setFormReportType(formReportType ?? null)
      setAutoSignOffEnabled(autoSignOffEnabled ?? false)
      setElationPdfNonFax(elationPdfNonFax ?? false)
      setFormDownloadable(formDownloadable ?? false)
      // @ts-ignore
      setPages(pages)
      setQuestions(questions)
      // @ts-ignore
      setRows(rows)
      // @ts-ignore
      setSections(sections)
      setCompletePage({
        redirectUrl,
        customCompletePage,
        hasRedirectRules,
      })
      setNotificationUsers(notificationUsers)
      setIsDirty(false)
      setServerFormId(formId)
      // @ts-ignore
      setInternalForm(internalForm)
      setMeasuresEnabledForm(measuresEnabledForm ?? false)
    },
    [parseFormFromJson, setFormName]
  )

  const formValues = React.useMemo(
    () => ({
      formName,
      formTextName,
      formReportType,
      autoSignOffEnabled,
      elationPdfNonFax,
      formDownloadable,
      pages,
      formDisplayName,
      formDescription,
      sections,
      questions,
    }),
    [
      formDescription,
      formDisplayName,
      formName,
      formTextName,
      formReportType,
      autoSignOffEnabled,
      elationPdfNonFax,
      formDownloadable,
      pages,
      questions,
      sections,
    ]
  )

  const formValuesWithArrays = React.useMemo(
    () => ({
      ...formValues,
      pages: _objectToArray(pages),
      questions: _objectToArray(questions),
    }),
    [_objectToArray, formValues, pages, questions]
  )

  const _formatErrors = React.useCallback(
    (errors: any) => {
      const formattedErrors = {
        form: [],
        questions: {},
      }

      errors.forEach((error: any) => {
        const path = error.split(' ')[0]

        if (path.includes('questions[')) {
          const pathWithIndex = path.split('.')[0]
          const _question = get(formValuesWithArrays, pathWithIndex)
          const parsedError = error.split(path)[1]
          const _questionId = _question.id

          if (Object.keys(formattedErrors.questions).includes(_questionId)) {
            // @ts-ignore
            if (!formattedErrors.questions[_questionId].includes(parsedError)) {
              // @ts-ignore
              formattedErrors.questions[_questionId].push(parsedError)
            }
          } else {
            // @ts-ignore
            formattedErrors.questions[_questionId] = [parsedError]
          }
        } else {
          // @ts-ignore
          formattedErrors.form.push(error)
        }
      })

      setFormErrors(formattedErrors.form)
      setQuestionErrors(formattedErrors.questions)
      if (isFilledArray(formattedErrors.form)) {
        setQuestionIdToScroll('FORM_TITLE')
      } else {
        setQuestionIdToScroll(Object.keys(formattedErrors.questions)[0] ?? null)
      }
    },
    [formValuesWithArrays]
  )

  const validateFormData = React.useCallback(async () => {
    try {
      await formBuilderSchema.validate(formValuesWithArrays, {
        abortEarly: false,
        context: { getQuestion },
      })
      setFormErrors([])
      setQuestionErrors({})
    } catch (validationError: any) {
      _formatErrors(validationError.errors)
      throw new ValidationError('Please review the form error messages')
    }

    return true
  }, [formValuesWithArrays, _formatErrors, getQuestion])

  const onPreviewForm = React.useCallback(
    async (formId: string) => {
      try {
        await validateFormData()
        if (formId) {
          window.open(
            `/r/preview/${formId}?response_type=form&show_footer=true`,
            '_blank'
          )
        }
      } catch (err) {
        // do nothing
      }
    },
    [validateFormData]
  )

  const getOnPreviewForm = React.useCallback(
    (formId: string) => () => onPreviewForm(formId),
    [onPreviewForm]
  )

  const handleDeletedItems = React.useCallback(async () => {
    if (!serverFormId) return

    const toDelete = {
      deleteConditionalRules: [],
      deleteConditionalRuleGroups: [],
      deleteQuestionRows: [],
      deleteQuestionColumns: [],
      deleteQuestionChoices: [],
      deleteQuestions: [],
      deletePages: [],
    }

    for (const i of deletedItems.conditional_rules) {
      // @ts-ignore
      toDelete.deleteConditionalRules.push(i?.id?.toString())
    }

    for (const i of deletedItems.conditional_rule_groups) {
      try {
        // @ts-ignore
        toDelete.deleteConditionalRuleGroups.push(i?.id?.toString())
        // eslint-disable-next-line no-empty
      } catch {}
    }

    for (const i of deletedItems.question_rows) {
      // @ts-ignore
      toDelete.deleteQuestionRows.push(i?.id?.toString())
    }

    for (const i of deletedItems.question_columns) {
      // @ts-ignore
      toDelete.deleteQuestionColumns.push(i?.id?.toString())
    }

    for (const i of deletedItems.question_choices) {
      // @ts-ignore
      toDelete.deleteQuestionChoices.push(i?.id?.toString())
    }

    for (const i of deletedItems.questions) {
      // @ts-ignore
      toDelete.deleteQuestions.push(i?.id?.toString())
    }

    for (const i of deletedItems.pages) {
      // @ts-ignore
      toDelete.deletePages.push(i?.id?.toString())
    }

    await formBuilderAPI.deleteFormResources(serverFormId, toDelete)
  }, [deletedItems, serverFormId])

  const buildFormRequestData = React.useCallback(
    (formName: string, formTextName: string) => ({
      name: formName,
      text: formTextName,
      [integration
        ? `${integration}_pdf_report_type`
        : 'elation_pdf_report_type']:
        integration && formReportType && formReportType !== ''
          ? formReportType
          : null,
      auto_sign_off: autoSignOffEnabled,
      elation_pdf_non_fax: elationPdfNonFax,
      downloadable: !!formDownloadable,
      is_internal_form: internalForm,
      measure_enabled: measuresEnabledForm,
      notification_users: notificationUsers,
      redirect_url: completePage?.redirectUrl,
      custom_complete_page: completePage?.customCompletePage || null,
      has_redirect_rules: completePage?.hasRedirectRules,
      pages: pagesArray.map((page: any) => {
        const _page = getObjectWithOrWithoutId(getPage, page.id)

        if (!_page.order && _page.order !== 0) {
          Sentry.captureEvent({
            message: 'Page order is required',
            level: 'error',
            tags: {
              context: 'FormBuilder',
            },
            extra: {
              page,
            },
          })
        }

        return {
          ..._page,
          sections: sectionsArray
            .filter((s) => s.page === page.id)
            .map((section) => {
              const _section = getObjectWithOrWithoutId(getSection, section?.id)
              return {
                ..._section,
                rows: rowsArray
                  .filter((r) => r?.section === section?.id)
                  .filter(
                    (r) =>
                      questionsArray.filter((q) => q.row === r.id).length !== 0
                  )
                  .map((row) => {
                    const _row = getObjectWithOrWithoutId(getRow, row.id)
                    return {
                      ..._row,
                      questions: questionsArray
                        .filter((q) => q.row === row.id)
                        .map((question) => {
                          const _question = getObjectWithOrWithoutId(
                            getQuestion,
                            question.id
                          )

                          return {
                            ..._question,
                            image:
                              _question.image === undefined
                                ? null
                                : _question.imageToDisplayOnBuilder,
                            question_type: `${_question.question_type.question_type}-${_question.question_type.question_subtype}`,
                          }
                        })
                        .filter(
                          (question) => question.isNew || question.hasChanged
                        ),
                    }
                  }),
              }
            }),
        }
      }),
    }),
    [
      autoSignOffEnabled,
      completePage,
      elationPdfNonFax,
      formDownloadable,
      formReportType,
      getPage,
      getQuestion,
      getRow,
      getSection,
      integration,
      internalForm,
      measuresEnabledForm,
      notificationUsers,
      pagesArray,
      questionsArray,
      rowsArray,
      sectionsArray,
    ]
  )

  const onSaveForm = React.useCallback(async () => {
    if (
      isSavingForm ||
      isFetchingForm ||
      (measuresEnabledForm && notIsSettings && measuresEnabled)
    )
      return

    // @ts-ignore
    setSelectedItem(null)

    try {
      setIsSavingForm(true)

      await validateFormData()
      await validateExtraContexts(extraContexts)
      await saveExtraContexts(extraContexts)
      await handleDeletedItems()

      const hasRedirectRules = completePage?.hasRedirectRules

      if (!hasRedirectRules && completePage?.data?.length) {
        await Promise.all(
          completePage?.data
            .filter((item) => !item.is_new)
            .map((item) => deleteCompletePageConditionalRuleById(item.id || ''))
        )

        await invalidateLoadCompletePageConditionalRule({
          form: resourceFormId,
        })
      }

      if (completePage?.data?.length && hasRedirectRules) {
        const separateRules = getSeparateCompleteConditionalRule(
          completePage?.data
        )
        if (Object.keys(separateRules.new) && separateRules.new.length) {
          await addNewCompletePageConditionalRules(separateRules.new)
        }
        if (Object.keys(separateRules.update) && separateRules.update.length) {
          await Promise.all(
            separateRules.update.map((item) =>
              updateCompletePageConditionalRules(item)
            )
          )
        }

        await invalidateLoadCompletePageConditionalRule({
          form: resourceFormId,
        })
      }

      const data = buildFormRequestData(formName, formTextName)
      const response = await formBuilderAPI.createOrUpdateForm(
        data,
        // @ts-ignore
        serverFormId
      )
      const responseFormId = response.id

      if (serverFormId) {
        // TODO: We are fetching the form from the BE again because
        // the response from update is incomplete (rows don't have the section
        // id for instance). We should update the BE in order to improve the
        // response from create/update, and then remove this fetch below.
        buildFromResponse(await API.getFormDetails(responseFormId))
      }

      if (
        appearanceDetailsForm &&
        Object.keys(appearanceDetailsForm || {}).length
      ) {
        await updateTeamConfig({
          data: {
            config: {
              form_appearance: appearanceDetailsForm,
            },
            teamId: zentakeContext.teamDetails?.id || 0,
          },
        })
      }
      await invalidateLoadQuestionByResourceId({
        form: resourceFormId,
        with_choices: true,
      })
      setIsDirty(false)

      if (isNewForm) {
        history.push(`/forms/${responseFormId}`, {
          blockLoading: true,
        })
      }

      toast.success(`Form ${serverFormId ? 'saved' : 'created'}`)
    } catch (error) {
      if (!(error instanceof ValidationError)) {
        Sentry.captureMessage('Error saving form', {
          extra: {
            error: JSON.stringify(error),
          },
        })
      }

      toast.error('Unable to Save')
    } finally {
      setIsSavingForm(false)
      setDeletedItems(INITIAL_DELETED_ITEMS)
    }
  }, [
    isSavingForm,
    isFetchingForm,
    measuresEnabledForm,
    notIsSettings,
    measuresEnabled,
    validateFormData,
    extraContexts,
    handleDeletedItems,
    completePage,
    buildFormRequestData,
    formName,
    formTextName,
    serverFormId,
    appearanceDetailsForm,
    resourceFormId,
    isNewForm,
    deleteCompletePageConditionalRuleById,
    addNewCompletePageConditionalRules,
    updateCompletePageConditionalRules,
    buildFromResponse,
    updateTeamConfig,
    zentakeContext.teamDetails?.id,
    history,
    INITIAL_DELETED_ITEMS,
  ])

  const orderAllQuestions = React.useCallback(() => {
    const pageArray = _objectToArray(pages).sort((a, b) => a.order - b.order)
    const sectionArray = _objectToArray(sections).sort(
      (a, b) => a.order - b.order
    )
    const rowArray = _objectToArray(rows).sort((a, b) => a.order - b.order)
    const questionArray = _objectToArray(questions).sort(
      (a, b) => a.order - b.order
    )

    const orderedQuestions: any[] = []

    pageArray.forEach((page: any) => {
      const sections = sectionArray.filter(
        (section: any) => section.page === page.id
      )
      sections.forEach((section: any) => {
        const rows = rowArray.filter((row: any) => row.section === section.id)
        rows.forEach((row: any) => {
          const questions = questionArray.filter(
            (question: any) => question.row === row.id
          )
          questions.forEach((question: any) => {
            orderedQuestions.push(question)
          })
        })
      })
    })
    return orderedQuestions
  }, [_objectToArray, pages, sections, rows, questions])

  const showDeleteConfirmation = React.useCallback(
    async () =>
      new Promise((resolve) =>
        zentakeContext.setAlertConfig({
          title: 'Are you sure you want to permanently delete this form?',
          description: (
            <>
              <p>
                Note: This form will be removed from all packets it is
                associated with.
              </p>
              {measuresEnabledForm && measuresEnabled ? (
                <p className="mt-2 items-center justify-center rounded border !border-orange-200 bg-orange-50 p-2 text-[#ffaa00]">
                  All tracked data related to this assessment will be
                  permanently lost.
                </p>
              ) : null}
            </>
          ),
          buttons: [
            {
              title: 'Delete',
              style: 'primary',
              danger: true,
              onPress: () => resolve(true),
            },
            {
              title: 'Cancel',
              onPress: () => resolve(false),
            },
          ],
          canDismiss: false,
        })
      ),
    [measuresEnabled, measuresEnabledForm, zentakeContext]
  )

  const onDeleteForm = React.useCallback(
    async (formId: string) => {
      const result = await showDeleteConfirmation()
      if (result) {
        setLoading(true)
        setDeleting(true)
        await API.deleteForm(formId)
        history.replace('/forms')
        setLoading(false)
        setDeleting(false)
        toast.success('Form deleted')
      }
    },
    [showDeleteConfirmation, history]
  )

  const getOnDeleteForm = React.useCallback(
    (formId: string) => () => onDeleteForm(formId),
    [onDeleteForm]
  )

  const reloadFormData = React.useCallback(async () => {
    if (!serverFormId) return

    try {
      setIsFetchingForm(true)

      const formResponse = await API.getFormDetails(serverFormId)
      buildFromResponse(formResponse)

      await invalidateLoadCompletePageConditionalRule({
        form: resourceFormId,
      })

      await invalidateLoadQuestionByResourceId({
        form: resourceFormId,
        with_choices: true,
      })

      setDeletedItems(INITIAL_DELETED_ITEMS)
      setIsDirty(false)
    } catch (error) {
      console.error('Erro ao recarregar formulário:', error)
      toast.error('Erro ao recarregar formulário')
    } finally {
      setIsFetchingForm(false)
    }
  }, [serverFormId, buildFromResponse, resourceFormId, INITIAL_DELETED_ITEMS])

  const buildPagesTree = React.useCallback((pages: any[]) => {
    const pagesMap = new Map()
    const mainPages: any[] = []

    pages.forEach((page) => {
      pagesMap.set(page.id, { ...page, children: [] })
    })

    pages.forEach((page) => {
      const pageNode = pagesMap.get(page.id)

      if (page.parent_page_id && pagesMap.has(page.parent_page_id)) {
        const parentNode = pagesMap.get(page.parent_page_id)
        parentNode.children.push(pageNode)
      } else {
        mainPages.push(pageNode)
      }
    })

    const sortPagesRecursively = (pageList: any[]) => {
      pageList.sort((a, b) => a.order - b.order)
      pageList.forEach((page) => {
        if (page.children.length > 0) {
          sortPagesRecursively(page.children)
        }
      })
    }

    sortPagesRecursively(mainPages)
    return mainPages
  }, [])

  const pagesTreeArray = React.useMemo(
    () => buildPagesTree(pagesArray),
    [buildPagesTree, pagesArray]
  )

  const contextProps: FormBuilderContextType = {
    ...formValues,
    // @ts-ignore
    addMultipleQuestions,
    addPage,
    addQuestion,
    addQuestionChoice,
    addRepeatingSectionAfter,
    addRow,
    addChildPageWithQuestion,
    // @ts-ignore
    addRowInBetween,
    addSection,
    buildFromResponse,
    conditionalLogicModalOpen,
    deletePage,
    deleteQuestion,
    deleteSection,
    deleting,
    duplicateQuestion,
    extraContexts,
    formErrors,
    getIsSelected,
    getOnDeleteForm,
    getOnPreviewForm,
    getPage,
    getQuestion,
    getCurrentQuestion,
    getAllSectionsForPage,
    getSectionsForPage,
    getRow,
    getSection,
    internalForm,
    appearanceDetailsForm,
    measuresEnabledForm,
    isDirty,
    isEditingDescription,
    isFetchingForm,
    isReordering,
    isSavingForm,
    loading,
    notificationUsers,
    onDeleteForm,
    onMovePageDown,
    onMovePageUp,
    onPreviewForm,
    onReorderQuestion,
    onReorderQuestionProp,
    onReorderQuestionToNewRow,
    onSaveForm,
    orderAllQuestions,
    pagesArray,
    pagesLength,
    pagesTreeArray,
    questionErrors,
    questionIdToScroll,
    questionValidationTypes,
    questionsArray,
    completePage,
    setCompletePage,
    removeQuestionChoice,
    reorderColumns,
    reorderSourceRow,
    resetSelectedItem,
    reloadFormData,
    rowToScroll,
    rows,
    rowsArray,
    selectedItem,
    serverFormId,
    setIsDirty,
    setAutoSignOffEnabled,
    setConditionalLogicModalOpen,
    setElationPdfNonFax,
    setExtraContexts,
    setFormDescription,
    setFormDisplayName,
    setFormDownloadable,
    setFormName,
    setFormReportType,
    setFormTextName,
    setInternalForm,
    setMeasuresEnabledForm,
    handleUpdateAppearanceDetails,
    setIsEditingDescription,
    setIsFetchingForm,
    setIsReordering,
    setNotificationUsers,
    setPage,
    setQuestion,
    setQuestions,
    setQuestionIdToScroll,
    setReorderColumns,
    setReorderSourceRow,
    setRowToScroll,
    setSelectedItem,
    shouldHideCreditCardQuestion,
    updateMultipleQuestions,
    validateFormData,
  }

  return (
    <FormBuilderContext.Provider value={contextProps}>
      {children}
    </FormBuilderContext.Provider>
  )
}

export const FormBuilderContextProvider = withRouter(
  ContextFormBuilderProviderBase
)

// Add a custom hook for using the context
export function useFormBuilder(): FormBuilderContextType {
  const context = React.useContext(FormBuilderContext)
  if (context === undefined) {
    throw new Error(
      'useFormBuilder must be used within a FormBuilderContextProvider'
    )
  }
  return context
}
